import { render } from "./radio-buttons-input.vue?vue&type=template&id=c7318b30"
import script from "./radio-buttons-input.vue?vue&type=script&lang=js"
export * from "./radio-buttons-input.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__